"use client";

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["onClickOutside"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getDocument } from "@faire/web--source/common/globals/getDocument";
import * as React from "react";
var ClickOutside = /*#__PURE__*/function (_React$Component) {
  function ClickOutside() {
    var _this;
    _classCallCheck(this, ClickOutside);
    _this = _callSuper(this, ClickOutside, arguments);
    _this.handle = function (event) {
      var onClickOutside = _this.props.onClickOutside;
      var el = _this.container;
      if (onClickOutside && el && event && !el.contains(event.target) && !ClickOutside.isFacebookClickEvent(event)) {
        onClickOutside(event);
      }
    };
    return _this;
  }
  /*
  Synthetic click events created from a Facebook form are causing click outside to close the brand page sign up modal.
  This checks targets the transient Facebook form to prevent it from triggering the onClickOutside.
   */
  // eslint-disable-next-line @faire/prefer-arrow-methods
  _inherits(ClickOutside, _React$Component);
  return _createClass(ClickOutside, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        onClickOutside = _this$props.onClickOutside,
        props = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement("div", _objectSpread(_objectSpread({}, props), {}, {
        ref: function ref(_ref) {
          _this2.container = _ref;
        }
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.onClickOutside && !prevProps.onClickOutside) {
        var _getDocument;
        (_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.addEventListener("click", this.handle, true);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.onClickOutside) {
        var _getDocument2;
        (_getDocument2 = getDocument()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.addEventListener("click", this.handle, true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _getDocument3;
      (_getDocument3 = getDocument()) === null || _getDocument3 === void 0 ? void 0 : _getDocument3.removeEventListener("click", this.handle, true);
    }
  }], [{
    key: "isFacebookClickEvent",
    value: function isFacebookClickEvent(event) {
      var _event$target, _event$target2, _event$target2$parent;
      return (event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.tagName) === "INPUT" && (event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : (_event$target2$parent = _event$target2.parentElement) === null || _event$target2$parent === void 0 ? void 0 : _event$target2$parent.action) === "https://www.facebook.com/tr/";
    }
  }]);
}(React.Component);
export { ClickOutside as default };